
<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销预测修改'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>预测基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail14">
                                        <el-form ref="form"
                                                 :rules="rules" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">

                                            <el-form-item  label="预测编码" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.id"
                                                          :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item  label="区域" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.areaStr"
                                                          :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item  label="国家名称" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.countryStr"
                                                          :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.proCode"
                                                          :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.proModel"
                                                          :disabled="true"></el-input>
                                            </el-form-item>
                                           <!-- <el-form-item label="型号属性" class="h-elformWrap-2">
                                                <el-input placeholder="" v-model="saveData.protype"
                                                          :disabled="true"></el-input>
                                            </el-form-item>-->
                                            <el-form-item label="数量" class="h-elformWrap-2">
                                                <el-input v-model="saveData.proNumber" placeholder="产品数量"
                                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="常规或改制" class="h-elformWrap-2" >
                                                <brselect category="shifou_dingzhi" :v="saveData.isSpecific"
                                                          v-model="saveData.isSpecific" placeholder="请选择"  :disabled=true
                                                          @change="changes()" />
                                            </el-form-item>
                                            <el-form-item label="改制大类" class="h-elformWrap-2"  v-if="saveData.isSpecific==2">
                                                <el-input v-model="saveData.specificReq"
                                                          :disabled="true"
                                                          placeholder="改制大类"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="改制要求" class="h-elformWrap-2" v-if="saveData.isSpecific==2">
                                                <el-input v-model="saveData.specificReform"
                                                          :disabled="true"
                                                          placeholder="改制要求"  >
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="单台价加(元)" class="h-elformWrap-2" v-if="saveData.isSpecific==2">
                                                <el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" :disabled="true"></el-input>
                                            </el-form-item>

                                            <el-form-item label="占用预排单类型" class="h-elformWrap-2"  v-if="saveData.protype=='自产'">
                                                <el-select v-model="saveData.isScheduling" clearable @change="isYp">
                                                    <el-option value="1" label="自己"></el-option>
                                                    <el-option value="2" label="他人"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="选择预排单号" class="h-elformWrap-2" v-if="isYPdisabled">
                                                <el-select v-model="saveData.getypData" clearable placeholder="请选择" allow-create filterable
                                                          :multiple="true" @change="getYbTable();;addNumber()">
                                                    <el-option v-for="(item, index) in ypIds" :key="index" :label="item.id"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                         <!--   <el-form-item label="预排数量" class="h-elformWrap-2" v-if="isYPdisabled">
                                                <el-input v-model="saveData.ypNumber" placeholder="产品数量"   @change="addNumber"
                                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                </el-input>
                                            </el-form-item>-->
                                           <!-- <el-form-item label="个人预测数量" class="h-elformWrap-2">
                                                <el-input v-model="saveData.oneNumber" placeholder="产品数量" @change="ypRelease">
                                                </el-input>
                                            </el-form-item>-->
                                            <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="saveData.isSpecific==2">
                                                <el-select  v-model="saveData.isOther" clearable @change="isYp">
                                                    <el-option value="1" label="自己"></el-option>
                                                    <el-option value="2" label="他人"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="使用已预测库存" class="h-elformWrap-2" v-if="saveData.isOther=='1' && saveData.isSpecific==2">
                                                <el-select v-model="saveData.useData" clearable placeholder="请选择" allow-create filterable
                                                            @change="addUseId();addNumber()" :multiple="true" :disabled="disabled" >
                                                    <el-option v-for="(item, index) in saveData.uids" :key="index" :label="item.code"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="使用他人已预测库存" class="h-elformWrap-2" v-if="saveData.isOther=='2' && saveData.isSpecific==2">
                                                <el-select v-model="saveData.useOtherData" clearable placeholder="请选择" allow-create filterable
                                                            @change="addUseIdOther();addNumber()" :multiple="true" :disabled="disabled">
                                                    <el-option v-for="(item, index) in saveData.otherUseIds" :key="index" :label="item.code"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="改制类型" class="h-elformWrap-2" v-if="saveData.isSpecific==2">
                                                <el-select   v-model="saveData.isReformStock" :disabled="true" >
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>
                                           <!-- <el-form-item label="他人预测数量" class="h-elformWrap-2" v-if="disabledOther">
                                                <el-input v-model="saveData.otherNumber" placeholder="产品数量"  @change="addNumber"
                                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                </el-input>
                                            </el-form-item>-->

                                            <!--OEM有发货方式-->
                                            <el-form-item label="发货方式" class="h-elformWrap-2">
                                                <el-select  v-model="saveData.deliveryMethod" :disabled="true">
                                                    <el-option value="1" label="直发"></el-option>
                                                    <el-option value="2" label="库发"></el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item label="是否实单" class="h-elformWrap-2"  >
                                                <el-select   v-model="saveData.isReal" :disabled="true">
                                                    <el-option value="0" label="备货"></el-option>
                                                    <el-option value="1" label="实单"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="预计交货时间" class="h-elformWrap-2"  >
                                                <el-date-picker v-model="saveData.deliveryDate" type="date" :clearable="false"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd" :placeholder="saveData.deliveryDate"
                                                                placeholder="请选择日期" :picker-options="pickerOptions">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="备注"  class="h-elformWrap-2" >
                                                <el-input v-model="saveData.remark" placeholder="备注" :disabled="true" ></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="subTo">确认提交</el-button>
            </div>
        </div>

        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-row " style="margin-top:30px;padding:0;" v-if="ycTable.length > 0">
                            <div class="h-rowCon" style="padding-bottom:0">
                                <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                    <div class="h-pieceTitle2"
                                         style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                        <h1>占用预测库存信息</h1>
                                    </div>
                                </div>
                                <el-table
                                        ref="multipleTable"
                                        :data="ycTable"
                                        stripe
                                        border
                                        max-height="500"
                                        style="width: 100%">
                                    <el-table-column
                                            type="index"
                                            label="#">
                                    </el-table-column>
                                    <el-table-column
                                            prop="id"
                                            :show-overflow-tooltip="true"
                                            label="预测编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="country"
                                            :show-overflow-tooltip="true"
                                            label="国家名称">
                                        <template slot-scope="scope">
                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="proModel"
                                            :show-overflow-tooltip="true"
                                            label="型号">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proCode"
                                            :show-overflow-tooltip="true"
                                            label="产品编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="protype"
                                            label="型号属性"
                                            :show-overflow-tooltip="true">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proNumber"
                                            :show-overflow-tooltip="true"
                                            label="数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="useNumber"
                                            :show-overflow-tooltip="true"
                                            label="可用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="recordNumber"
                                            :show-overflow-tooltip="true"
                                            label="已占用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="useInventory"
                                            :show-overflow-tooltip="true"
                                            label="使用库存数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="stockStatus"

                                            label="库存状态">
                                        <template slot-scope="scope">
                                            <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="cuname"

                                            label="创建人">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="h-row " style="margin-top:30px;padding:0;" v-if="otherTable.length > 0">
                            <div class="h-rowCon" style="padding-bottom:0">
                                <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                    <div class="h-pieceTitle2"
                                         style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                        <h1>占用他人预测库存信息</h1>
                                    </div>
                                </div>
                                <el-table
                                        ref="multipleTable"
                                        :data="otherTable"
                                        stripe
                                        border
                                        max-height="500"
                                        style="width: 100%">
                                    <el-table-column
                                            type="index"
                                            label="#">
                                    </el-table-column>
                                    <el-table-column
                                            prop="id"
                                            :show-overflow-tooltip="true"
                                            label="预测编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="country"
                                            :show-overflow-tooltip="true"
                                            label="国家名称">
                                        <template slot-scope="scope">
                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="proModel"
                                            :show-overflow-tooltip="true"
                                            label="型号">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proCode"
                                            :show-overflow-tooltip="true"
                                            label="产品编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="protype"
                                            label="型号属性"
                                            :show-overflow-tooltip="true">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proNumber"
                                            :show-overflow-tooltip="true"
                                            label="数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="useNumber"
                                            :show-overflow-tooltip="true"
                                            label="可用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="recordNumber"
                                            :show-overflow-tooltip="true"
                                            label="已占用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="useInventory"
                                            :show-overflow-tooltip="true"
                                            label="使用库存数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="stockStatus"
                                            label="库存状态">
                                        <template slot-scope="scope">
                                            <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="cuname"
                                            label="创建人">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="h-row " style="margin-top:30px;padding:0;" v-if="ybTable.length > 0">
                            <div class="h-rowCon" style="padding-bottom:0">
                                <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                    <div class="h-pieceTitle2"
                                         style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                        <h1>占用预排信息</h1>
                                    </div>
                                </div>
                                <el-table
                                        ref="multipleTable"
                                        :data="ybTable"
                                        stripep
                                        border
                                        max-height="500"
                                        style="width: 100%">
                                    <el-table-column
                                            type="index"
                                            label="#">
                                    </el-table-column>
                                    <el-table-column
                                            prop="id"
                                            :show-overflow-tooltip="true"
                                            label="预测编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="country"
                                            :show-overflow-tooltip="true"
                                            label="国家名称">
                                        <template slot-scope="scope">
                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="proModel"
                                            :show-overflow-tooltip="true"
                                            label="型号">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proCode"
                                            :show-overflow-tooltip="true"
                                            label="产品编码">
                                    </el-table-column>
                                    <el-table-column
                                            prop="protype"
                                            label="型号属性"
                                            :show-overflow-tooltip="true">
                                    </el-table-column>
                                    <el-table-column
                                            prop="proNumber"
                                            :show-overflow-tooltip="true"
                                            label="数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="useNumber"
                                            :show-overflow-tooltip="true"
                                            label="可用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="recordNumber"
                                            :show-overflow-tooltip="true"

                                            label="已占用数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="cuname"
                                            label="创建人">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>







<script>
    import ss from '../../../api/SystemService';

    export default {
        data() {
            return{
                orderNumber:'',
                dialogFormVisible:false,
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                    },
                    {
                        specificId: '12',
                        des: '电动门功能'
                    }
                ],
                ycTable:[],
                ycList:[],
                userRole: [],
                instid: '',
                showhistory: false,
                isYPdisabled:false,
                ypIds:[],
                ybTable:[],
                disabledOther:false,
                getOtherData:[],
                otherTable:[],
                ypDisabled:true,
                saveData:{
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    isOther:null,
                    isReal:null,
                    isScheduling:null,
                    getypData:[],
                    preId:'',
                    deliveryMethod:'',
                    isReformStock:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:'',
                    oldNumber:'',
                    proModel:'',
                    proCode:'',
                    country:'',
                    countryStr:'',
                    area:'',
                    areaStr:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    specific:[],
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:'',
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                gjCo:[],
                f: {
                    productModel: '',
                    productCode: ''
                },
                pModel: [],
                pCode: [],
                pCodecopy: [],
                items: {},
                disabled:true,

                rules: {
                    proNumber: [
                        {required: true, message: '数量不能为空', trigger: 'blur'},
                    ],

                },

            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if((to.path=='/yuce/wxyuceReport' || to.path=='/yuce/wxyuceReport-goods'
                || to.path=='/yuce/wxyuceReport-public' || to.path=='/yuce/wxyuceReport-summary')
                && from.path == '/yuce/wxyuceRevise'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            changeNum(v) {
                v.useId = '';
                v.useMeg = '';
                v.useData = '';
            },

            selectDingzhi(v) {
                ss.OrderMainService.listDingzhi({
                    matecode: v.proCode
                }).then(rd => {
                    if (rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            v.describe.push({
                                des: rd[i].des,
                                specificId: rd[i].id
                            });
                        }
                    }
                })
            },

            changes(v) {
                if (v.isSpecific == 1) {
                    v.specific = '';
                    v.specificReq = '';
                    v.specificId = '';
                }
            },

            addspecificId(v) {
                v.specificId = '';
                for (var i = 0; i < v.specific.length; i++) {
                    for (var j = 0; j < v.describe.length; j++) {
                        if (v.specific[i] == v.describe[j].des) {
                            if (v.specificId != null && v.specificId != '') {
                                v.specificId = v.specificId + v.describe[j].specificId + ", "
                            } else {
                                v.specificId = v.describe[j].specificId + ", "
                            }
                        }
                    }
                }
            },

            query() {
                var obj= {
                    id: this.$route.query.id
                }

                ss.waixiao.showReviseList(obj).then(rd => {
                    this.saveData = rd[0];
                    this.saveData.oldNumber = this.saveData.proNumber;
                    var cou = this.$store.getters.dictlist("YLCountry_agent");
                    for (var j = 0; j < cou.length; j++) {
                        if (cou[j].code == this.saveData.country) {
                            this.saveData.countryStr = cou[j].name
                        }
                    }
                    var quyu = this.$store.getters.dictlist("dj_foreign_area");
                    for (var j = 0; j < quyu.length; j++) {
                        if (quyu[j].code == this.saveData.area) {
                            this.saveData.areaStr = quyu[j].name
                        }
                    }

                    //todo 可能需要审批权限
                    this.disabled = false;

                    if(this.saveData.deliveryMethod || this.saveData.deliveryMethod==0){
                        this.saveData.deliveryMethod = this.saveData.deliveryMethod.toString()
                    }
                    if(this.saveData.isScheduling){
                        this.saveData.isScheduling = this.saveData.isScheduling.toString()
                    }
                    if(this.saveData.isOther ){
                        this.saveData.isOther = this.saveData.isOther.toString()
                    }
                    if(this.saveData.isReal || this.saveData.isReal==0){
                        this.saveData.isReal = this.saveData.isReal.toString()
                    }
                    if(this.saveData.isReformStock || this.saveData.isReformStock==0){
                        this.saveData.isReformStock = this.saveData.isReformStock.toString()
                    }

                    this.decide();
                })

            },

            subTo() {
                this.tableData = [];
                this.tableData.push(this.saveData);

             /*   if(this.tableData[0].preId || this.tableData[0].preId !=null ||this.tableData[0].preId!=""){
                    var num = 0;
                    for(var y=0;y<this.ybTable.length;y++){
                        num += this.ybTable[y].useNumber;
                    }
                    if(this.tableData[0].ypNumber > num){
                        return this.$msg.msge("预排数量不能大于所选预排可用数量总计");
                    }
                }*/
                if(this.tableData[0].otherUseId || this.tableData[0].otherUseId !=null ||this.tableData[0].otherUseId!=""){
                    var num = 0;
                    for(var y=0;y<this.otherTable.length;y++){
                        num += this.otherTable[y].useNumber;
                    }
                    if(this.tableData[0].otherNumber > num){
                        return this.$msg.msge("借用他人数量不能大于所选借用他人预测可用数量");
                    }
                }
                this.$msg.confirm("确认提交?", () => {
                    if (this.tableData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                            if (this.tableData[0].proNumber =='') {
                                this.$msg.msge("请输入产品数量!");
                                f = false;
                            }
                            if (this.tableData[0].isOther ==1 && this.tableData[0].useData=='') {
                                this.$msg.msge("请选择使用已预测库存!");
                                f = false;
                            }
                            if (this.tableData[0].isOther ==2 && this.tableData[0].useOtherData=='') {
                                this.$msg.msge("请选择使用他人已预测库存!");
                                f = false;
                            }

                            if (this.tableData[0].isScheduling && this.tableData[0].getypData=='') {
                                this.$msg.msge("请选择预排单号!");
                                f = false;
                            }

                        if (f) {
                            console.log(this.tableData,"/////////////");
                            ss.waixiao.submitRevise(this.tableData).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.$router.go(-1);
                            });
                        }
                    }
                })
            },
            renovate() {
                this.$router.go(-1);
            },

/********************************************************************************************/
            addNumber(){

                var num = 0
                //已预测占用
                for(var i=0;i<this.ycTable.length;i++){

                    if(this.ycTable[i].recordNumber != 0){
                        num += parseInt(this.ycTable[i].recordNumber) + parseInt(this.ycTable[i].useNumber);
                    }else{
                        num += parseInt(this.ycTable[i].useNumber);
                    }
                }
                 //预排占用
                for(var i=0;i<this.ybTable.length;i++) {
                    if (this.ybTable[i].recordNumber != 0) {
                        num += parseInt(this.ybTable[i].recordNumber) + parseInt(this.ybTable[i].useNumber);
                    } else {
                        num += parseInt(this.ybTable[i].useNumber);
                    }
                }

                this.saveData.proNumber =  parseInt(!this.saveData.otherNumber?0:this.saveData.otherNumber)+num;

                this.$forceUpdate();
            },




            addUseId(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.useId='';
                this.saveData.useMeg='';
                this.ycTable = [];

                if (this.saveData.useData && this.saveData.useData.length != 0 && this.saveData.uids && this.saveData.uids.length != 0) {
                    for (var i = 0; i < this.saveData.useData.length; i++) {
                        for (var j = 0; j < this.saveData.uids.length; j++) {

                            if (this.saveData.useData[i] == this.saveData.uids[j].code) {
                                this.saveData.useId = this.saveData.useData+ ","
                                this.saveData.useMeg = this.saveData.useData + ","
                            }
                        }

                         for(var t=0;t<this.ycList.length;t++){
                            if(this.ycList[t].id == this.saveData.useData[i]){
                                this.ycTable.push(this.ycList[t]);
                            }
                        }
                    }
                    this.saveData.useId = this.saveData.useId.substring(0,this.saveData.useId.length-1);
                    this.saveData.useMeg = this.saveData.useMeg.substring(0,this.saveData.useMeg.length-1);
                }

                this.$forceUpdate();

            },
            addUseIdOther(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.otherUseId='';
                this.otherTable = [];
                if (this.saveData.useOtherData && this.saveData.useOtherData.length != 0 && this.saveData.otherUseIds && this.saveData.otherUseIds.length != 0) {
                    if(this.saveData.useOtherData.length > 1){
                        return this.$msg.msge("只能选择一个他人预测");
                    }
                    for (var i = 0; i < this.saveData.useOtherData.length; i++) {
                        for (var j = 0; j < this.saveData.otherUseIds.length; j++) {
                            if (this.saveData.useOtherData[i] == this.saveData.otherUseIds[j].code) {
                                this.saveData.otherUseId = this.saveData.useOtherData + ","
                            }
                        }

                        for(var t=0;t<this.getOtherData.length;t++){
                            if(this.getOtherData[t].id == this.saveData.useOtherData[i]){
                                this.otherTable.push(this.getOtherData[t]);
                            }
                        }
                    }
                    //截取最后一位逗号
                    this.saveData.otherUseId = this.saveData.otherUseId.substring(0,this.saveData.otherUseId.length-1);

                }
                this.$forceUpdate()
            },
            getYbTable(){
                this.ybTable = [];
                this.saveData.preId='';
                for(var i=0;i<this.saveData.getypData.length;i++){
                    for(var j=0;j<this.ypIds.length;j++){

                        if (this.saveData.getypData[i] == this.ypIds[j].id) {
                            this.saveData.preId = this.saveData.getypData + ","
                        }

                        if(this.saveData.getypData[i]==this.ypIds[j].id){
                            this.ybTable.push(this.ypIds[j]);
                        }
                    }
                }
                //截取最后一位逗号
                this.saveData.preId = this.saveData.preId.substring(0,this.saveData.preId.length-1);
            },
            decide() {
                if (this.saveData.proModel != this.items.proModel && this.saveData.proCode != this.items.proCode) {
                    this.items.proModel = this.saveData.proModel;
                    this.items.proCode = this.saveData.proCode;
                    // this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                }
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.saveData.protype = rd;
                })
                this.isYp();
                //this.getYPlist();
                // this.selectDingzhi(this.items);
                this.selectStock();
                this.selectStockOther();
            },

            ypRelease(){
                if(this.saveData.oneNumber > this.saveData.ypNumber){
                    this.ypDisabled = false
                }else {
                    this.ypDisabled = true
                }

            },

            selectStock() {
                this.ycList = [];
                this.saveData.uids = [];
                var obj= {
                    id: this.saveData.id,
                    proCode: this.saveData.proCode
                }

                ss.waixiao.selectReviseStockUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ycList = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                    if (this.saveData.useMeg && this.saveData.useMeg != '') {
                        //循环设置
                        this.saveData.useData = _.split(this.saveData.useMeg || [], ",");
                    }

                    this.addUseId();
                })
            },
            selectStockOther() {
                this.saveData.otherUseIds = [];
                this.getOtherData=[];
                var obj= {
                    id: this.saveData.id,
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectStockOtherUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.getOtherData = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.otherUseIds.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                    if (this.saveData.otherUseId && this.saveData.otherUseId != '') {
                        this.saveData.useOtherData =  _.split(this.saveData.otherUseId || [], ",");
                    }
                    this.addUseIdOther();
                })
            },

            getYPlist(){
                this.saveData.getypData = [];
                var obj= {
                    id: this.saveData.id,
                    proCode: this.saveData.proCode,
                    myOrOther:this.saveData.isScheduling
                }

                this.ypIds=[];
                ss.waixiao.selectYpUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ypIds = rd;
                    }
                    if (this.saveData.preId && this.saveData.preId != '') {
                        this.saveData.getypData = this.saveData.preId.split(",");
                    }
                    this.getYbTable();
                })
            },
            isYp(){
                if(this.saveData.isScheduling){
                    this.isYPdisabled = true;
                    this.getYPlist()
                }else {
                    this.saveData.getypData = [];
                    this.isYPdisabled = false;
                }

                if(this.saveData.isOther && this.saveData.isOther == '1'){
                    this.saveData.useOtherData = [];
                    this.otherTable = [];
                }else if(this.saveData.isOther && this.saveData.isOther == '2'){
                    this.saveData.useData = [];
                    this.ycTable = [];
                }else {
                    this.saveData.useData = [];
                    this.ycTable = [];
                    this.saveData.useOtherData = [];
                    this.otherTable = [];
                }


            },
            selectCode(v) {
                for (var key in this.items.prolist) {
                    if (this.saveData.proModel == key) {
                        this.saveData.proCode = this.items.prolist[key];
                    }
                }
                this.decide();
            },

            showCountry(data) {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                            if(country[j].code == data.country){
                                data.country = country[j].name;
                            }
                        }
                    }
                    //this.clickmodel(data)
                })
            },
            isShowDia(parentToChildData,isVastus){
                let self = this
                self.dialogFormVisible =isVastus;
                this.showCountry(parentToChildData);
            },



        }
    }
</script>
<style>
    .icon .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }
	.icon .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .icon .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 90%;
    }

    .yhbrselect .el-input__inner {
        height: 0.6rem;
        border: 0;
        color: #2785e7;
        font-size: 0.18rem;
        background: 0;
    }

    .yhbrselect .el-input__inner:focus {
        border: 1px solid #2785e7;
        box-shadow: 0 0 0.16rem rgba(39, 133, 231, 0.35) inset;
    }

    .h-formBorder.ljjclassforms .el-input__inner {
        border: 0;
        border-bottom: 1px solid #d1d1d1;
    }

    .ljjclasstans .el-dialog__footer {
        text-align: center;
    }
    .weekplandetail14 .h-formbLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .weekplandetail14 .h-formbLine .el-form-item__content {
        width: 65%;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
    .ljjtablepaddings12 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
</style>
